exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.con-vs-popup[data-v-9893252e] .vs-popup {\n  width: 1200px !important;\n  height: auto !important;\n}\r\n", ""]);

// exports
